import { Outlet }         from 'react-router-dom';
import { Layout, Result } from 'antd';
import { Header }         from '@/features/header/header';
import { Footer }         from '@/features/footer/Footer';

const ErrorBoundary = () => {
  return (
    <div>
      <Result status="warning" title={'An unexpected error occurred. Please try again later or contact support if the issue persists.'} />
    </div>
  )
};

const AppRoot = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header />
      <Layout.Content>
        <Outlet />
      </Layout.Content>
      <Footer />
    </Layout>
  )
};

export { ErrorBoundary };
export default AppRoot;
